/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CriticalPopulationMonitoringAvailabilityResponse,
  CriticalPopulationMonitoringSummaryResponse,
  CriticalPopulationsMonitoringResponse,
  GetClientCriticalPopulationsMonitoringAvailabilityParams,
  GetClientCriticalPopulationsMonitoringParams,
  GetClientCriticalPopulationsMonitoringSummariesParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientCriticalPopulationsMonitoring = (
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationsMonitoringResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientCriticalPopulationsMonitoringQueryKey = (
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCriticalPopulationsMonitoringQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalPopulationsMonitoringQueryKey(
      oktaUserId,
      clientId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>
  > = ({ signal }) =>
    getClientCriticalPopulationsMonitoring(
      oktaUserId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalPopulationsMonitoringQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>
>;
export type GetClientCriticalPopulationsMonitoringQueryError =
  ErrorType<unknown>;

export function useGetClientCriticalPopulationsMonitoring<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: undefined | GetClientCriticalPopulationsMonitoringParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoring<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoring<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalPopulationsMonitoring<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoring>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientCriticalPopulationsMonitoringQueryOptions(
    oktaUserId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const getClientCriticalPopulationsMonitoringSummaries = (
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationMonitoringSummaryResponse[]>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring-summaries`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientCriticalPopulationsMonitoringSummariesQueryKey = (
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringSummariesParams
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring-summaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCriticalPopulationsMonitoringSummariesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalPopulationsMonitoringSummariesQueryKey(
      oktaUserId,
      clientId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>>
  > = ({ signal }) =>
    getClientCriticalPopulationsMonitoringSummaries(
      oktaUserId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalPopulationsMonitoringSummariesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>>
  >;
export type GetClientCriticalPopulationsMonitoringSummariesQueryError =
  ErrorType<unknown>;

export function useGetClientCriticalPopulationsMonitoringSummaries<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
          >,
          TError,
          Awaited<
            ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoringSummaries<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
          >,
          TError,
          Awaited<
            ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoringSummaries<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalPopulationsMonitoringSummaries<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringSummaries>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetClientCriticalPopulationsMonitoringSummariesQueryOptions(
      oktaUserId,
      clientId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const getClientCriticalPopulationsMonitoringAvailability = (
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationMonitoringAvailabilityResponse[]>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring-availability`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientCriticalPopulationsMonitoringAvailabilityQueryKey = (
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsMonitoringAvailabilityParams
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/critical-populations/monitoring-availability`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCriticalPopulationsMonitoringAvailabilityQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
    >,
    TError = ErrorType<unknown>
  >(
    oktaUserId: string,
    clientId: number,
    params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getClientCriticalPopulationsMonitoringAvailability
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customAxios>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetClientCriticalPopulationsMonitoringAvailabilityQueryKey(
        oktaUserId,
        clientId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
      >
    > = ({ signal }) =>
      getClientCriticalPopulationsMonitoringAvailability(
        oktaUserId,
        clientId,
        params,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(oktaUserId && clientId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetClientCriticalPopulationsMonitoringAvailabilityQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
    >
  >;
export type GetClientCriticalPopulationsMonitoringAvailabilityQueryError =
  ErrorType<unknown>;

export function useGetClientCriticalPopulationsMonitoringAvailability<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getClientCriticalPopulationsMonitoringAvailability
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getClientCriticalPopulationsMonitoringAvailability
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoringAvailability<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getClientCriticalPopulationsMonitoringAvailability
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getClientCriticalPopulationsMonitoringAvailability
            >
          >
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationsMonitoringAvailability<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalPopulationsMonitoringAvailability<
  TData = Awaited<
    ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
  >,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsMonitoringAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getClientCriticalPopulationsMonitoringAvailability>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetClientCriticalPopulationsMonitoringAvailabilityQueryOptions(
      oktaUserId,
      clientId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
